import React, { Component } from 'react'
import { Link } from 'react-router-dom'
        
class Header extends Component {
        constructor () {
                super()
                this.state = {
                        me: []
                }
        }
        
        componentWillMount () {
                axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
        }
        
        componentDidMount () {
                //get current user info
                axios.get('/api/me').then(response => {
                        this.setState({
                              me: response.data
                        })
                })
        }
        
        logout (e) {
                e.preventDefault()
                axios.post('/logout').then(response => {
                        window.localStorage.removeItem('token')
                        window.location.href='/'
                })
        }

        render () {
                return (  
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid p-0">
                        <button className="btn btn-link d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="material-icons md-18 text-white">apps</i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="nav navbar-nav ml-auto">
                                <li className="nav-item active">
                                    <div className="dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {this.state.me.name}さん、こんにちは
                                        </a>
                                        <div className="dropdown-menu p-0" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="#" onClick={this.logout}>ログアウト</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
		</nav>

                )
        }
}


export default Header